// CRA proxies development requests to the local Apache server on port 80.
// Production keeps its existing endpoint unless explicitly configured at build time.
export const API_BASE_URL = (
    process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === 'development'
        ? '/horizont/horizont-be'
        : 'https://horizontclinic.com/horizont-be')
).replace(/\/+$/, '');
